import { render } from "./StandardForm.vue?vue&type=template&id=2afd6b44&scoped=true"
import script from "./StandardForm.vue?vue&type=script&lang=js"
export * from "./StandardForm.vue?vue&type=script&lang=js"

import "./StandardForm.vue?vue&type=style&index=0&id=2afd6b44&lang=css"
import "./StandardForm.vue?vue&type=style&index=1&id=2afd6b44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afd6b44"]])

export default __exports__